import { dummyStocks } from "../dummyData";
import {
  handleError,
  handleRequestError,
  hostUrl,
  jsonHeaders,
  message,
  request,
  withDummyFallback,
} from "./core";

export const listStocks = () => {
  const config = {
    method: "get",
    maxBodyLength: Infinity,
    url: hostUrl("/stocks/list"),
    headers: jsonHeaders(),
  };
  return request(config)
    .then((response) => withDummyFallback(response.data, dummyStocks))
    .catch((error) =>
      handleRequestError(error, dummyStocks, { networkFallback: [] }),
    );
};

export const createStocks = (payload) => {
  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: hostUrl("/users/stocks/create"),
    headers: jsonHeaders(),
    data: JSON.stringify(payload),
  };
  return request(config)
    .then(() => {
      message.success("Stock settings saved");
    })
    .catch((error) => {
      message.error(error?.response?.data?.message || "Server is Down");
      handleError(error);
    });
};

export const deleteStocks = (id) => {
  if (!id) return;
  const config = {
    method: "delete",
    maxBodyLength: Infinity,
    url: hostUrl("/users/stocks/delete"),
    headers: jsonHeaders(),
    data: JSON.stringify({ id }),
  };
  return request(config)
    .then((response) => response.data)
    .catch((error) => {
      handleError(error);
      message.error(error?.response?.data?.message || "Server is Down");
    });
};
